
/** @jsxImportSource @emotion/react */
import React from 'react';
import Container from '@mui/material/Container';
import Slider from '@mui/material/Slider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import tw, { styled } from 'twin.macro';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import useWorkshopMorale from '../../hooks/useWorkshopMorale';
import useStorageData from '../../hooks/useStorageData';
import useLocalization from '../../hooks/useLocalization';

import List from '../../data/list.json';


const FilterPanel = () => {

  const { setWorkshop, workshop, currentWorkshop } = useWorkshopMorale();
  const { sortPreset, setSortPreset } = useStorageData();
  const { t, lang } = useLocalization();


  return (
  <FilterPanelWrapper>
    <FilterContent>
      <div>
        <FormControl size="small" css={tw`
          w-[150px]
        `}>
          <InputLabel>{t(`sort`)}</InputLabel>
          <Select
            value={sortPreset.sortBy}
            label={t(`sort`)}
            onChange={(e) => {
              setSortPreset({
                key : 'sortBy',
                value : e.target.value
              });

            }}
          >
            {Object.keys(List.Sort).map((key,index) => <MenuItem value={key} key={`option_${key}`}>{List.Sort[key].label[lang]}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl css={tw`
          ml-4
        `}>
          {navigator.userAgent !== "ReactSnap" && 
          <RadioGroup
            value={sortPreset.order}
            name="radio-buttons-group"
            onChange={(e) => {
              setSortPreset({
                key : 'order',
                value : e.target.value
              })
            }}
            row
          >
            <RadioLabel value="asc" control={<Radio />} label={t(`asc`)} />
            <RadioLabel value="dsc" control={<Radio />} label={t(`dsc`)} />
          </RadioGroup>}
        </FormControl>
        <FormControl css={tw`
          ml-4
          text-black
        `}>
          <FormControlLabel control={<Checkbox checked={sortPreset.showReadyOnly} onChange={(e) => {
            setSortPreset({
              key : 'showReadyOnly',
              value : e.target.checked
            })
          }}/>} label={t(`craftableOnly`)} />
        </FormControl>
        
      </div>
      <div>
        <SliderWrapper>
          <SliderHeader>
            <SliderLabel>{`${t(`workshopMorale`)}：`}</SliderLabel>
            <SliderInput
                hiddenLabel
                value={parseInt(workshop.morale,10)}
                size="small"
                onChange={(e) => {
                  setWorkshop({ key: 'morale', value : e.target.value });
                }}
              />
          </SliderHeader>
          <Slider   
            value={workshop.morale ? parseInt(workshop.morale,10) : 1} 
            onChange={(e) => {
              setWorkshop({ key: 'morale', value : e.target.value });
            }}
            min={0}
            max={45}
            step={1}
            aria-label={t(`workshopMorale`)} valueLabelDisplay="auto"/>
        </SliderWrapper>
        <RankWrapper>
          <SliderHeader>
            <SliderLabel>{`${t(`workshopRank`)}：`}</SliderLabel>
            <SliderInput
                hiddenLabel
                value={workshop.workshops[currentWorkshop].rank}
                size="small"
                onChange={(e) => {
                  setWorkshop({ key: 'rank', target : currentWorkshop, value : e.target.value });
                }}
              />
          </SliderHeader>
          <Slider   
            value={workshop.workshops[currentWorkshop].rank ? parseInt(workshop.workshops[currentWorkshop].rank,10) : 1} 
            onChange={(e) => {
              setWorkshop({ key: 'rank', target : currentWorkshop, value : e.target.value });
            }}
            min={1}
            max={5}
            step={1}
            aria-label={t(`workshopRank`)} valueLabelDisplay="auto"/>
        </RankWrapper>
      </div>
    </FilterContent>
  </FilterPanelWrapper>)
}

export default React.memo(FilterPanel);


const FilterPanelWrapper = styled.div`
  ${tw`
    relative
    w-full
    top-0
    left-0
    h-[98px]
    bg-white
    z-10
    transition-[box-shadow]
  `}
`

const FilterContent = styled.div`
  ${tw`
    flex
    w-[calc(100vw - 354px - 334px)]
    max-w-[1200px]
    px-6
    mx-auto
    justify-between
    h-[98px]
    items-center
  `}
`

const SliderWrapper = styled(FormControl)`
  ${tw`
    w-[150px]
    self-end
  `}
`

const RankWrapper = styled(SliderWrapper)`
  ${tw`
    w-[150px]
    ml-8

  `}
`

const SliderHeader = styled.div`
  ${tw`
    flex
    items-center
    justify-between
  `}
`

const SliderLabel = styled(FormLabel)`
  ${tw`
  `}
`

const SliderInput = styled(TextField)`
  ${tw`
    w-7    
    inline-block
    
  `}
  input{
    ${tw`
      p-[2px]
      text-center
      text-[12px]
    `}
  }
`

const RadioLabel = styled(FormControlLabel)`
  ${tw`
    text-black
  `}
`